<div class="review-row">
  <label fd-form-label>{{ label }}:</label>
  @if (!control) {
    <div
      class="details-value"
      i18n-title="
        XTOL|Unified review row - Uneditable
        input@@organizations.unified-review-row.uneditableField"
      title="To edit this field, go back to the previous step"
    >
      {{ value }}
    </div>
  }
  @if (!editable) {
    <div class="details-value">{{ control.value }}</div>
  }
  @if (control && editable) {
    <app-reactive-edit-in-place
      class="details-value"
      [placeholder]="placeholder"
      [control]="control"
      [customErrorMessage]="customErrorMessage"
    ></app-reactive-edit-in-place>
  }
</div>
